export const commitments = [
  { title: "Des conseils de spécialistes", text: "Des experts en investissements financiers à vos côtés." },
  { title: "Un contrôle régulier", text: "Suivi des résultats et des performances de vos placements." },
  { title: "Des supports de premier ordre", text: "Une sélection rigoureuse auprès des meilleurs acteurs." },
  { title: "Une liberté totale", text: "Changer d'orientation, de société de gestion ou résilier à tout moment." },
  { title: "Une information transparente", text: "Des reportings clairs, sans jargon." },
];
